import { createFileRoute } from '@tanstack/react-router'

import PageFolderList from '@/pages/PageFolderList'

export const Route = createFileRoute('/folder/list')({
  component: PageFolderList
})
